import { SVGProps } from 'react';

export const EditQld = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			{...props}
		>
			<path
				d="M18.41 5.80013L17.2 4.59013C16.42 3.81013 15.15 3.81013 14.37 4.59013L11.69 7.27013L3 15.9601V20.0001H7.04L15.78 11.2601L18.41 8.63013C19.2 7.85013 19.2 6.58013 18.41 5.80013ZM6.21 18.0001H5V16.7901L13.66 8.13013L14.87 9.34013L6.21 18.0001ZM11 20.0001L15 16.0001H21V20.0001H11Z"
				fill="#008635"
			/>
		</svg>
	);
};
